export default __webpack_public_path__ + "static/media/popupCardfive.56c65bdd.png";